'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkButton = (0, _react.memo)(function (_ref) {
    var component = _ref.component,
        doExecuteAction = _ref.doExecuteAction,
        doSetReturn = _ref.doSetReturn,
        valid = _ref.valid;

    var _useState = (0, _react.useState)(null),
        _useState2 = _slicedToArray(_useState, 2),
        guid = _useState2[0],
        setGuid = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isDisabled = _useState4[0],
        setIsDisabled = _useState4[1];

    var label = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Text');
    var target = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Target');
    var alignment = (0, _metrixCommon.getElementValueByCode)(component.elements, 'Alignment') || _metrixCommon.Alignments.center;
    var actionCode = (0, _metrixCommon.getElementValueByCode)(component.elements, 'ActionCode');

    var options = (0, _metrixCommon.getElementsByCode)(component.elements, 'Options');
    var isNext = options && options.length && options.some(function (option) {
        return option.code === 'Next';
    });

    (0, _react.useEffect)(function () {
        var params = new URLSearchParams(window.location.search);
        setGuid(params.get('entity'));
    }, []);

    var handleClick = function handleClick() {
        setIsDisabled(true);
        doExecuteAction({ actionCode: actionCode, guid: guid, target: target, isNext: isNext });

        setTimeout(function () {
            setIsDisabled(false);
        }, 2000);
    };

    return _react2.default.createElement(
        _metrixCommon.Container,
        { fullSize: true, inline: true, horizontalAlignment: alignment },
        _react2.default.createElement(_metrixCommon.PrimaryButton, { text: label,
            top: _metrixCommon.Sizes.lg,
            bottom: _metrixCommon.Sizes.lg,
            clickEvent: handleClick,
            disabled: !valid || isDisabled
        })
    );
}, _fastDeepEqual2.default);

LinkButton.propTypes = {
    component: _propTypes2.default.shape({
        elements: _propTypes2.default.array.isRequired
    }).isRequired,
    doExecuteAction: _propTypes2.default.func.isRequired
};

exports.default = LinkButton;